import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Pretendard';
    src: url('/fonts/Pretendard-Regular.otf') format('opentype'),
         url('/fonts/Pretendard-Regular.woff') format('woff');
    font-weight: 1 1000;
    font-style: normal;
  }
  
  @font-face {
    font-family: 'Pretendard Bold';
    src: url('/fonts/Pretendard-Bold.woff2') format('woff2');
    font-weight: 1 1000;
  }

  @font-face {
    font-family: 'Pretendard SemiBold';
    src: url('/fonts/Pretendard-SemiBold.woff2') format('woff2');
    font-weight: 1 1000;
  }

  @font-face {
    font-family: 'Pretendard Medium';
    src: url('/fonts/Pretendard-Medium.woff2') format('woff2');
    font-weight: 1 1000;
  }

  /* 전역 스타일을 작성합니다. */
  body {
    font-family: 'Pretendard' !important;
    margin: 0;
    padding: 0;

    ::-webkit-scrollbar {
      display: none;
    }
  }
`;

export default GlobalStyle;
